import { inject, Injectable } from '@angular/core';
import { filter, map, switchMap } from 'rxjs';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { concatLatestFrom } from '@ngrx/operators';

import { EffectsBase } from '@ps/core-data-access';

import { SecureAuthStorageService } from '../../services/secure-auth-storage/secure-auth-storage.service';
import { AuthSessionActions } from './auth-session.actions';
import { selectRememberMe } from './auth-session.selectors';

@Injectable()
export class AuthStorageEffects extends EffectsBase {
  private readonly _store = inject(Store);
  private readonly _actions$ = inject(Actions);
  private readonly _authStorage = inject(SecureAuthStorageService);

  public hydrate$ = createEffect(() =>
    this._actions$.pipe(
      ofType(AuthSessionActions.hydrate),
      switchMap(() =>
        this._authStorage
          .load()
          .pipe(
            map((settings) =>
              settings
                ? AuthSessionActions.hydrateSuccess({ user: settings.user })
                : AuthSessionActions.hydrateFailure(),
            ),
          ),
      ),
    ),
  );

  public saveAuthToStorage$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(AuthSessionActions.loginSuccess),
        concatLatestFrom(() => this._store.select(selectRememberMe)),
        filter(([{ user }]) => !!user),
        switchMap(([{ user }, rememberMe]) =>
          this._authStorage.save({ user, rememberMe }),
        ),
      ),
    { dispatch: false },
  );
}
